import request from '@/utils/request'

// 获取商城交易统计数据
export function getShopTradeStatistics() {
  return request({
    url: '/statistics/order/shoptrade',
    method: 'get'
  })
} 